//#region src/modules/ServicePeriods/hooks/group-evals.ts
function groupEvalsBySourceRefId(activityEvals) {
	return activityEvals.reduce((acc, activityEval) => {
		const existing = acc[activityEval.sourceRefId];
		if (existing) existing.push(activityEval);
		else acc[activityEval.sourceRefId] = [activityEval];
		return acc;
	}, {});
}
//#endregion
export { groupEvalsBySourceRefId };

//# sourceMappingURL=group-evals.js.map